import React from "react";
import Spinner from "../Spinner";
import styles from "./styles.module.scss";

// Единый центрированный лоадер с блюром фона (DEV-1003).
// Использует fixed-позиционирование, поэтому всегда находится в одной и той же
// точке экрана независимо от того, отрисован ли уже layout (меню/хедер) или нет.
// Это убирает эффект "двух прелоудеров", когда лоадер прыгал из центра вьюпорта
// в центр контентной области. Сам индикатор — общий Spinner.
const CenteredLoader: React.FC = () => {
  return (
    <div className={styles.overlay}>
      <Spinner />
    </div>
  );
};

export default CenteredLoader;
